<template>
  <div class="d-flex flex-column align-center justify-center pa-8" style="gap: 24px">
    <Typography as="h4" variant="h-4" class="text-center">Merge Complete</Typography>

    <Typography variant="body-1" class="text-center">
      The user accounts have been successfully merged.
    </Typography>

    <lottie :options="backflipOptions" :width="160" :height="160" />

    <Button color="brandCyan" class="white--text" @click="$emit('done')">Done</Button>
  </div>
</template>

<script>
import Lottie from "vue-lottie/src/lottie.vue";
import * as backflipData from "@/assets/robin/Backflip.json";
import Button from "@/components/generic/Button.vue";
import Typography from "@/components/generic/Typography.vue";

export default {
  name: "MergeSuccess",
  components: { Button, Lottie, Typography },
  emits: ["done"],
  data() {
    return {
      backflipOptions: { animationData: backflipData.default, loop: false, autoplay: true },
    };
  },
};
</script>
